import { useMutation, useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";
import { NavLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoadingButton from "../../../components/Loading/LoadingButton";
import { getRequestByAuth } from "../../../function/helper";
import style from "./SidebarContent.module.css";

export default function SidebarContent() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationKey: ["logOutDigikalaSeller"],
    mutationFn: () =>
      getRequestByAuth("/v2/digikala/logOutSeller").then(res => {
        if (res && res.status === 200) {
          queryClient.refetchQueries({
            queryKey: ["DigikalaSeller"],
          });

          return navigate("/");
        }

        Swal.fire({
          icon: "error",
          confirmButtonText: "باشه",
          text: res.message,
        });

        return null;
      }),
  });

  function onSubmit() {
    Swal.fire({
      icon: "warning",
      text: "آیا میخواهید از دیجی‌کالا خارج شوید ؟",
      confirmButtonText: "بله خروج",
      confirmButtonColor: "red",
      cancelButtonText: "خیر",
      customClass: "rtl-all",
      showCancelButton: true,
    }).then(res => {
      if (res.isConfirmed) {
        mutate();
      }
    });
  }

  return (
    <div className="d-flex flex-column align-items-center p-3 mt-5 mt-lg-0 h-100">
      <div
        style={{ width: 123, height: 100 }}
        className="border border-1 rounded"
      >
        <img
          src="/collaborator/digikala-logo.png"
          className="w-100 h-100 object-fit-cover"
        />
      </div>

      <p className="mb-0 mt-2">پنل فروشنده دیجی‌کالا</p>

      <section
        className={classNames(
          "d-flex flex-column w-100 mt-4",
          style.sidebarItems
        )}
      >
        <NavLink
          to="information"
          className={({ isActive }) => (isActive ? style.active : "")}
          end={true}
        >
          اطلاعات
        </NavLink>

        <NavLink
          to="orders"
          className={({ isActive }) => (isActive ? style.active : "")}
        >
          سفارشات
        </NavLink>

        <LoadingButton
          isLoading={isPending}
          className={classNames("buttonUi", style.exitButton)}
          onClick={onSubmit}
          title={isPending ? "در حال خروج" : "خروج از دیجی‌کالا"}
        />
      </section>
    </div>
  );
}
